import { BrowserRouter, Routes, Route, Link, useLocation, useNavigate  } from 'react-router-dom';
import React, { useState, useEffect, useRef } from 'react';

import SelecJuegoLateral from './SelecJuegoLateral';
import SelecJuego from './SelecJuego';
import juegos from '../assets/juegos.json';

type FechaJuego = {
    fecha: string;
    textoFecha:string;
    diasDif:number;
    medalla:number;
  };


export default function AbajoJuegos({ idJuegoAct, mostrarDias = true, diaActual = -1}: {idJuegoAct: any; mostrarDias?: boolean; diaActual?: number; }) {

  
  const [otrosJuegos, setOtrosJuegos]=useState(juegos);
  const [juegoAct, setJuegoAct]=useState(juegos[0]);
  const navigate = useNavigate();
  const [iniciado, setIniciado] = useState(false);
  const numDias=4;
  const [dias, setDias] = useState<FechaJuego[]>([]);
  if(!iniciado){
    Iniciar();
  }
  

  function ClickJuego(juego: any){
    navigate("/"+juego.escena+"/0");
  }

  function ClickDia(dia: FechaJuego){
    //alert(dia.diasDif);
    navigate("/"+juegoAct.escena+"/"+dia.diasDif);
    window.location.reload();
  }

  function Iniciar(){
    setIniciado(true);
    let oJuegos =[];
    let juego=juegos[0];
    for(var i=0; i<juegos.length;i++){
      if(juegos[i].id==idJuegoAct){
        setJuegoAct(juegos[i]);
        juego=juegos[i];
      }else{
        oJuegos.push(juegos[i]);
      }
    }
    setOtrosJuegos(oJuegos);
    let diasEntontrados=0;
    let diasAct =[];
    let iDias=0;
    const dayNames = ["Domingo", "Lunes", "Martes","Miércoles","Jueves","Viernes","Sabado"];

    while(diasEntontrados<numDias){
      iDias++;
      var today = new Date();
      today.setDate(today.getDate() - iDias);
      var textoFecha="";
      if(iDias==0){
        textoFecha="Hoy "+today.getDate();
      }else if(iDias==1){
        textoFecha="Ayer "+today.getDate();
      }else{
        textoFecha = dayNames[today.getDay()] + " "+today.getDate();
      }
      var medalla=-2;
      var medallaConseguida=localStorage.getItem("medalla_"+juego.escena+"_"+today.getFullYear()+"-"+(today.getMonth()+1)+"-"+today.getDate());
      if(medallaConseguida!=null){
        medalla=Number(medallaConseguida);
      }
      if(medalla==-2 && iDias !== diaActual){
        diasAct.push({fecha:today.toString(), textoFecha:textoFecha, medalla:medalla, diasDif:iDias});
        diasEntontrados++;
      }
      
    }
    setDias(diasAct);
    
  }

  


return (

    <section className="game-footer" id='abajo-juegos'>
      <div className="game-footer__inner">

        <div className={`footer-juego-grid ${!mostrarDias ? 'footer-juego-grid--solo-juegos' : ''}`}>
          {mostrarDias && <h3 className="footer-juego__titulo footer-juego__titulo--dias">Más {juegoAct.nombre}</h3>}
          <h3 className="footer-juego__titulo footer-juego__titulo--juegos">Más juegos</h3>

          {mostrarDias && (
            <div className="otrosDias__contenedor">
              {dias.map((diaAct, i) => (
                      <div className="otroDia" onClick={() => ClickDia(diaAct)} key={i}>
                          <h2>{diaAct.textoFecha}</h2>
                      </div>
              ))}
            </div>
          )}

          {otrosJuegos.map((juego, i) => (
                  <SelecJuego nombre={juego.nombre} frase={juego.frase} idJuego={juego.id} icono={juego.icono} color={juego.color} clicked={() => ClickJuego(juego)} key={juego.id}></SelecJuego>
          ))}
        </div>

      </div>
    </section>
    

    )
    



   
  
}